@for (item of timePeriodNotifications; track trackByTimePeriodNotifications(item)) {

@if (item.notifications.length > 0) {
<div class="rpc-notifications-list">

    <div class="rpc-notifications-list-title">
        {{item.title | translate}}
    </div>

    @for (notification of item.notifications; track trackByNotificationItemType(notification)) {

    @if (notification.isGroup) {
    <notification-group class="rpc-notifications-list-group"
        [notificationItem]="notification | cast: NotificationGroupItem" [dateFormat]="item.dateFormat"
        (navigateToNotificationEntity)="onNavigateToNotificationEntity($event)">
    </notification-group>
    } @else {
    <notification-item class="rpc-notifications-list-item" [notification]="notification | cast: NotificationPlainItem"
        [dateFormat]="item.dateFormat" (navigateToNotificationEntity)="onNavigateToNotificationEntity($event)">
    </notification-item>
    }
    }

</div>
}
}

<div class="rpc-notifications-list">

    @if (hasAnyNotifications) {
    <div class="rpc-notifications-list-note">
        {{'NOTIFICATION_LIST.TITLES.NOTIFICATIONS_MESSAGE' | translate}}
    </div>
    } @else {
    <div class="rpc-notifications-list-empty">

        <img class="rpc-notifications-list-empty-img" src="assets/images/decoration/notifications/empty.webp" alt="" />

        <div class="rpc-notifications-list-empty-text">
            {{'NOTIFICATION_LIST.TITLES.NO_NOTIFICATIONS_MESSAGE' | translate}}
        </div>

    </div>
    }

</div>